import src from "IMAGE";
export default { src, width: 1008, height: 1008, blurWidth: 0, blurHeight: 0};
